import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent } from '../ui/card';
import { AlertTriangle } from 'lucide-react';

function SuperadminCriticalMatchesTile() {
  const [matches, setMatches] = useState([]);
  const [avgSatisfaction, setAvgSatisfaction] = useState(null);
  const [expanded, setExpanded] = useState(false);

useEffect(() => {
  const fetchCriticalMatches = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/superadmin-stats/critical-matches`, {
        withCredentials: true,
      });
      setMatches(res.data.criticalMatches || []);
      setAvgSatisfaction(res.data.avgScore || null);
    } catch (err) {
      console.error('Fehler beim Abrufen kritischer Matches:', err);
    }
  };

  fetchCriticalMatches();
}, []);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <Card className="h-full">
      <CardContent className="p-6 space-y-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <AlertTriangle size={28} className="text-red-500" />
            <div>
              <p className="text-sm text-gray-400">Kritische Matches</p>
              <p className="text-xl font-bold">
                {matches.length > 0
                  ? `${matches.length} auffällige Paare`
                  : 'Keine kritischen Matches'}
              </p>
              {avgSatisfaction !== null && (
                <p className="text-xs text-gray-300">
                  ⌀ Zufriedenheit: {avgSatisfaction.toFixed(2)} von 5
                </p>
              )}
            </div>
          </div>
          {matches.length > 0 && (
            <span
              onClick={handleToggle}
              className="text-sm text-blue-400 underline cursor-pointer"
            >
              {expanded ? 'Schließen' : 'Anzeigen'}
            </span>
          )}
        </div>

        {expanded && (
          <ul className="mt-2 text-sm text-gray-300 list-disc list-inside">
            {matches.map((match, index) => (
                <li key={index}>
                    {match.company}: {match.menteeName} + {match.mentorName} → Feedback: {match.menteeScore}/{match.mentorScore}
                </li>
                ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}

export default SuperadminCriticalMatchesTile;
